const validate = values => {
  const errors = {}

  if (!values.poll_form?.question) {
    errors.poll_form = {
      ...errors.poll_form,
      question: "The poll question is required!",
    }
  }

  if (
    values.poll_form?.options?.filter(
      option => option.answer && option.answer.trim()
    ).length < 2
  ) {
    errors.poll_form = {
      ...errors.poll_form,
      options: { _error: "You have to add at least 2 valid options." },
    }
  }

  if (!values.poll_form?.name) {
    errors.poll_form = {
      ...errors.poll_form,
      name: "The poll name is required!",
    }
  }

  return errors
}

export default validate
